export default class TableData {
  constructor(
    public items: any[],
    public pages: number,
    public count: number
  ) {}
}
